export default __webpack_public_path__ + "static/media/experience.7de110c4.png";